import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ShopifyShipFrom = {
  id: 'shopifyshipfrom',
  displayName: <FormattedMessage {...messages.shopifyshipfrom} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'ShopifyShipFromLocation',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
